import jQuery = require("jquery");
import _ = require("underscore");
import "jquery-validation";

export module JQueryValidationOptions {
    export function register() {
        jQuery.validator.addMethod("greaterThan", function (value, element, param) {
            var thisValue, greaterValue, target;
            target = $(param);
            if (this.settings.onfocusout) {
                target.off(".validate-greaterThan").on("blur.validate-greaterThan", function () {
                    $(element).valid();
                });
            }

            thisValue = parseInt($(element).val().toString(), 10);
            greaterValue = parseInt(target.val(), 10);
            if (_.isFinite(thisValue) && _.isFinite(greaterValue)) {
                return thisValue > greaterValue;
            }
            return true;

        }, "value is too large");

        jQuery.validator.addMethod("notEqual", function (value, element, param) {
            return this.optional(element) || value != $(param).val();
        }, "value must be different");

        jQuery.validator.setDefaults({
            highlight: function (element) {
                $(element).closest('.form-group, .form-group-sm, .form-group-lg').addClass('has-error');
            },
            unhighlight: function (element) {
                $(element).closest('.form-group, .form-group-sm, .form-group-lg').removeClass('has-error');
            },
            errorElement: 'span',
            errorClass: 'has-error',
            errorPlacement: function (error, element) {
                if (element.parent('.input-group').length) {
                    error.insertAfter(element.parent());
                } else {
                    error.insertAfter(element);
                }
            }
        });
    }
}